export default "__VITE_ASSET__Cbh7LfvI__"